import * as action_types from '../actions/action_types';

const initialState = {
  selectedAlert: {},
  data: [],
};

export const EEDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case action_types.PASS_ALERTS_DATA:
      return {
        ...state,
        selectedAlert: action.data,
      };
    case action_types.GET_DETAILS_BY_ALERT_ID:
      return Object.assign({}, state, {
        data: action.payload,
      });
    default:
      return state;
  }
};
